import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=863e56f6&scoped=true&"
import script from "./Authenticate.vue?vue&type=script&lang=js&"
export * from "./Authenticate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863e56f6",
  null
  
)

export default component.exports